import * as type from '@app/constants/signOut'

export const signOut = () => ({
  type: type.SIGN_OUT_USER,
})

export const revokeToken = () => ({
  type: type.REVOKE_TOKEN,
})
